<template>
 <div id="rbTypes">
   <TypeItem v-for="(rebateType,index) in $store.state.initData.rebateType" :key="index" :index="index+''"
   @itemclick="itemclick"
   :rebateTypeName="rebateType['typename']" 
   :selectedBool="defaultSelectedIndex === index"
   :currentIndex="index"></TypeItem>
   <!-- <TypeItem></TypeItem> -->
 </div>
</template>

<script>
import TypeItem from './TypeItem.vue';
 export default {
   data () {
     return {
      defaultSelectedIndex: 0,
     }
   },
   components: {
    TypeItem,
   },
   methods:{
    itemclick(index){
      // console.log('点击回传了');
      // console.log(index);
      this.defaultSelectedIndex = index;
      this.$emit("rebateitemclick", this.$store.state.initData.rebateType[index]['typeid'])
    }
   }
 }
</script>

<style>
#rbTypes{
  float: left;
  display: -webkit-box;
  display: -ms-flexbox;
  /* width: 200%; */
  width: 100%;
  flex-direction: row;
  align-items: Center; /*垂直居中*/
  overflow-x:auto;
  /* 下面的操作都是为了隐藏滑条 */
  scrollbar-width: none;
  -ms-overflow-style: none;
  /* overflow: hidden; */
}
#rbTypes::-webkit-scrollbar{
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/views/SdkV3/rebate/RebateTypes.vue